import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { getModeTheme } from '../styles/state/selectors';
import { useBreakingPoints } from './useBreakpoint';

export const useNotification = () => {
  const mode = useSelector(getModeTheme());
  const { isDesktop } = useBreakingPoints();

  const notify = (label: string, type: 'success' | 'error' | 'warning') =>
    toast(label, {
      theme: mode === 'dark' ? 'light' : 'dark',
      type,
      position: isDesktop ? 'bottom-center' : 'top-center',
    });

  return {
    notify,
  };
};
